import { Component } from "react";
import { captureBoundaryError } from "../../monitoring/sentry";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Unknown error" };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
    captureBoundaryError(error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--cream)",
        padding: 24,
      }}>
        <div style={{
          width: "100%",
          maxWidth: 480,
          background: "var(--warm-white)",
          border: "1px solid var(--border)",
          borderRadius: "var(--radius-lg)",
          padding: 40,
          textAlign: "center",
          boxShadow: "var(--shadow-lg)",
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>⚠</div>
          <h2 style={{
            fontFamily: "var(--font-display)",
            fontWeight: 300,
            fontSize: 28,
            marginBottom: 10,
            color: "var(--ink)",
          }}>
            Something went wrong
          </h2>
          <p style={{ fontSize: 14, color: "var(--ink-muted)", marginBottom: 8 }}>
            An unexpected error occurred. Reloading the page usually fixes it.
          </p>
          {this.state.message && (
            <p style={{
              fontSize: 12,
              color: "var(--ink-hint)",
              fontFamily: "var(--font-mono, monospace)",
              background: "var(--cream)",
              border: "1px solid var(--border)",
              borderRadius: "var(--radius-sm)",
              padding: "8px 12px",
              marginBottom: 24,
              wordBreak: "break-word",
            }}>
              {this.state.message}
            </p>
          )}
          <button
            className="btn btn-primary"
            onClick={() => window.location.reload()}
            style={{ minWidth: 160 }}
          >
            Reload page
          </button>
        </div>
      </div>
    );
  }
}
